import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaiuTransactionRoutingModule } from './paiu-transaction-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PaiuTransactionRoutingModule
  ]
})
export class PaiuTransactionModule { }
